import { css } from '@linaria/core'

export const elIsLoading = css``
export const elIsActive = css``
export const elIsUsed = css``
export const elIsFullPage = css``
